module.exports = __webpack_public_path__ + "img/ghost.86113407.gif";